import React from 'react'
import Slider, { Settings } from 'react-slick'
import {useResizeDetector} from 'react-resize-detector'

import ProductThumbnail from '../Products/ProductThumbnail'
import { Collections_collections_edges } from './_gql-types/Collections'


interface Props {
  collection: Collections_collections_edges
}

export default function CollectionSlider({collection}: Props) {
  const {width, ref} = useResizeDetector()

  const slides = !!width ? (width > 900 ? 4 : width > 350 ? 2 : 1) : 4

  const settings: Settings = {
    dots: true,
    infinite: false,
    slidesToShow: slides+0.2,
    slidesToScroll: slides,
    autoplay: false,
    swipeToSlide: true,
  }

  return (
    <div ref={ref}>
      <h3 className="pb-3">{collection.node.name}</h3>

      <Slider className="product-slider" {...settings}>
        {collection.node.products?.edges.map(({node}) => (
          <ProductThumbnail key={node.id} {...node} />
        ))}
      </Slider>
    </div>
  )
}
